import React, { useState } from 'react';
import { TrashIcon, FolderIcon, CrossIcon } from '../icons';
import PopupContainer from './PopupContainer';
import { DeleteFileConfirmation } from './ConfirmationPopup';

const IconButton = ({ Icon, onClick, label, disabled, withBorder }) => (
  <button
    onClick={onClick}
    aria-label={label}
    disabled={disabled}
    className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-200 ${
      withBorder ? 'border border-[#ECECEC] dark:border-[#202020]' : ''
    } ${
      disabled
        ? 'opacity-30 cursor-not-allowed'
        : 'hover:bg-[#F1F1F1] dark:hover:bg-[#2A2A2A]'
    }`}
  >
    <Icon size={20} className="text-[#121212] dark:text-[#D0D0D0]" />
  </button>
);

export default function BatchActionBar({ selectedCount, onDelete, onMove, onCancel }) {
  const [isConfirmingDelete, setIsConfirmingDelete] = useState(false);

  return (
    <>
      <div className="flex items-center gap-3">
        <span className="text-sm font-medium text-[#121212] dark:text-[#D0D0D0]">
          {selectedCount} selected
        </span>
        <div className="flex items-center gap-3">
          <IconButton Icon={FolderIcon} onClick={onMove} label="Move items" disabled={selectedCount === 0} />
          <IconButton Icon={TrashIcon} onClick={() => setIsConfirmingDelete(true)} label="Delete items" disabled={selectedCount === 0} />
          <IconButton Icon={CrossIcon} onClick={onCancel} label="Cancel selection" withBorder />
        </div>
      </div>

      <PopupContainer isOpen={isConfirmingDelete} onClose={() => setIsConfirmingDelete(false)}>
        <DeleteFileConfirmation
          onClose={() => setIsConfirmingDelete(false)}
          onConfirm={async () => {
            await onDelete();
            setIsConfirmingDelete(false);
          }}
        />
      </PopupContainer>
    </>
  );
}
